import { connect } from 'react-redux';
import { AppState } from '../../app.state';
import { ManageServiceRecordComponent } from './manage-service-record.component';

export const ManageServiceRecord = connect((sState: AppState) => ({
  sState,
}))(ManageServiceRecordComponent as any) as unknown as typeof ManageServiceRecordComponent;
